import { render, staticRenderFns } from "./requestForm.vue?vue&type=template&id=dfc58b06&scoped=true&"
import script from "./requestForm.vue?vue&type=script&lang=js&"
export * from "./requestForm.vue?vue&type=script&lang=js&"
import style0 from "./requestForm.vue?vue&type=style&index=0&id=dfc58b06&prod&scoped=true&lang=css&"
import style1 from "./requestForm.vue?vue&type=style&index=1&id=dfc58b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc58b06",
  null
  
)

export default component.exports